import { createSelector, createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const printDocSlice = createSlice({
	name: "printDocSlice",
	initialState: INITIAL_STATE,
	reducers: {
		printRequest: (state) => {
			state.isFetching = true;
		},
		printSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		printFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetPrint: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

export const { printRequest, printSuccess, printFailuer, resetPrint } =
	printDocSlice.actions;

export default printDocSlice.reducer;
